import React, { useEffect, useState } from 'react';

function SplashScreen({ onEnter, onPlayMusic, isContentLoaded }) {
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (!isContentLoaded) return;

    const timer = setTimeout(() => {
      if (onPlayMusic) onPlayMusic();
      setIsFadingOut(true);
      onEnter();
    }, 8000);

    return () => clearTimeout(timer);
  }, [isContentLoaded, onEnter, onPlayMusic]);

  const handleClick = () => {
    if (!isContentLoaded) return;
    if (onPlayMusic) onPlayMusic();
    setIsFadingOut(true);
    onEnter();
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full h-screen bg-black bg-cover bg-center z-[9999] transition-opacity duration-1000 ease-in-out ${
        isFadingOut ? 'opacity-0' : 'opacity-100'
      }`}
      onClick={handleClick}
      style={{
        cursor: isContentLoaded ? 'pointer' : 'default',
        backgroundImage: `url(${process.env.PUBLIC_URL}/splash.webp)`,
      }}
    >
      <div className='flex flex-col items-center justify-center h-full'>
        <div
          className='mb-3 opacity-0 animate-fadeIn'
          style={{ transform: 'translateX(18px)' }}
        >
          <img
            src='/hand.png'
            alt='Enter'
            className='w-28 h-28 md:w-40 md:h-40 object-contain'
          />
        </div>
        <div
          className={`font-antelope-bold-caps text-[1.575rem] uppercase opacity-0 transition-opacity text-[#F7EDDE] duration-1000 ease-in-out ${
            isContentLoaded ? 'opacity-100' : ''
          }`}
          style={{ color: '#F7EDDE' }}
        >
          ENTER HERE
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
